import { Component } from "react";
import React from "react";
// import "./Cometblackstorm.css";
import { Link } from "react-router-dom";
import Navbar from "../../Home/Components/Nav";
import Footer from "../../Home/Components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import Contactus from "../../contact/Container/Contactformcon";
import HeroPriceSection from "../../MgComet/Components/HeroPriceSection";
import ReusableImageSections from "../../MgComet/CometImageSections";

const windsorImages = [
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor-ev-pro%2Fcuv-bn-dsc-036.webp?alt=media&token=fb9a42cc-b256-4e6f-bd1e-cbc307c8173b",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor-ev-pro%2Fcuv-bn-dsc-045.webp?alt=media&token=a993b1c6-406c-48d3-b382-c177a17ab9c2",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor-ev-pro%2Fcuv-bn-dsc-043.webp?alt=media&token=091e4939-36cb-43ff-aa59-21739890f6f6",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor-ev-pro%2Fcuv-bn-dsc-039.webp?alt=media&token=ebc07c61-5360-49e0-8b07-dc2216beb34a",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor-ev-pro%2Fcuv-bn-dsc-044.webp?alt=media&token=ed4fdc70-856a-4cac-b4cb-0a827cbf2eca",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor-ev-pro%2Fcuv-bn-dsc-041.webp?alt=media&token=42b31fa5-78c7-4438-a2ed-3e7d9c82e456",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor-ev-pro%2Fcuv-bn-dsc-042.webp?alt=media&token=c5955c26-55d8-4f7c-8346-03d926f5de19",
];

class Windsorevpro extends Component {
  render() {
    return (
      <div id="container">
        <Navbar />

        {/* HERO SECTION (Reusable) */}
        <HeroPriceSection
          basePrice="BAAS RANGE STARTS AT"
          mainPrice="₹9.99 LAKH + BATTERY RENTAL @ ₹3.9*/km"
          buttonText="Download Brochure"
          desktopBg="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor-ev-pro%2Fcuv-bn-dsc-033.webp?alt=media&token=6afbd443-6b4a-4dc9-8354-4216ee9ef276"
          mobileBg="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor-ev-pro%2Fcuv-bn-dsc-033-portrait.webp?alt=media&token=9a421939-ce93-4e7e-bfe9-57fe7a245b15"
          overlayWidth="55vw"   
        />

        {/* Breadcrumb */}
        <div style={{ height: "40px", marginTop: "8px", marginLeft: "50px" }}>
          <Link to="/" style={{ textDecoration: "none", color: "grey" }}>
            <b>Home</b>
          </Link>
          <Link
            to="/Cometevblackstorm"
            style={{ textDecoration: "none", color: "grey" }}
          >
            &nbsp;&nbsp;MG Windsor Ev Pro
          </Link>
        </div>

        {/* Image Sections */}
        <ReusableImageSections images={windsorImages} />
        <Contactus someValue="Commit" />
        <Footer />
      </div>
    );
  }
}

export default Windsorevpro;
